import Constants from 'expo-constants';

import type { PageBuilderButtonStore } from '@fhs/cms-groq-queries';

export const hrefByPlatform: Record<PageBuilderButtonStore['platform'], string> = {
  'app-store': Constants.expoConfig?.extra?.eas?.appStoreUrl ?? '',
  'google-play': Constants.expoConfig?.extra?.eas?.playStoreUrl ?? '',
};
